import React from "react"

import "./index.scss"
import ChatInput from "../ChatInput"
import SuggestToolbar from "../SuggestToolbar"

const ConversationBottom = ({
  createMessage,
  setPeopleSideBar,
  inputRef,
  handleOpenSuggestion,
  newDesign,
  fromCommentsInput,
  inputPlaceholder,
}) => {
  return (
    <div
      className={fromCommentsInput ? "comments-input" : "conversation-bottom"}>
      <ChatInput
        createMessage={createMessage}
        inputRef={inputRef}
        newDesign={newDesign}
        inputPlaceholder={inputPlaceholder}
        fromCommentsInput={fromCommentsInput}
      />
      {!newDesign && (
        <SuggestToolbar
          setPeopleSideBar={setPeopleSideBar}
          handleOpenSuggestion={handleOpenSuggestion}
        />
      )}
    </div>
  )
}

export default ConversationBottom
